import React from 'react'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import _helpers from '@toasttab/shared/src/globals/_helpers'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { useNavContext } from '../useNavContext'

const MobileMenuFooter = ({
  dataTestId = 'MobileMenuFooter'
}: {
  dataTestId?: string
}) => {
  const { t } = useI18next()
  const {
    heapClasses,
    navigationData,
    salesPhoneNumber,
    showLogin,
    showRequestDemo,
    showRestaurantSearch,
    showSalesInMobileMenu
  } = useNavContext()
  return (
    <div className='font-effra' data-testid={dataTestId}>
      {showRestaurantSearch ? (
        <a
          className={`${heapClasses?.restaurantSearch} block border-b border-color-gray-25 -mx-4 px-4 py-5 before:content-icon-nav-location before:relative before:top-[6px] before:mr-2 text-blue-75 hover:text-blue-100 text-base font-semibold`}
          href='https://www.toasttab.com/local?referrer=pos'
        >
          {t('Search Toast Restaurants')}
        </a>
      ) : null}
      {showLogin ? (
        <a
          className='block py-5 before:content-icon-nav-account before:relative before:top-[6px] before:mr-2 text-blue-75 hover:text-blue-100 text-base font-semibold'
          href={navigationData?.loginUrl}
        >
          {t('Login')}
        </a>
      ) : null}
      {showRequestDemo ? (
        <Button classes='!block mb-2 py-5' href={navigationData?.demoUrl}>
          {t('Get a Demo')}
        </Button>
      ) : null}
      {showSalesInMobileMenu && salesPhoneNumber ? (
        <Button
          classes='!block py-5'
          dataTestId='MobileMenuFooter-callSales'
          href={`tel:${salesPhoneNumber.replace(/[^0-9]/gi, '')}`}
          variation='secondary'
        >
          <span className='font-semibold'>{t('Call Sales')}</span>{' '}
          {salesPhoneNumber}
        </Button>
      ) : null}
    </div>
  )
}

export default MobileMenuFooter
